<template>
  <div class="sortby">
    <AkParagraph class="ds-leading-normal">
      <AkToggleV2
        id="sortby"
        v-model:value="toggle"
        data-testid="sortby-toggle"
        @update:value="togleValue"
      />
      <span class="ds-ml-2">{{ t('discovery.filters.sortby.newDiscovery') }}</span>
    </AkParagraph>
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';
import { AkParagraph, AkToggleV2 } from '@ankorstore/design-system';

const props = defineProps<{ currentSort: string }>();
const emit = defineEmits(['update:sortBy']);

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const toggle = ref(!!props.currentSort);
const items = ref([
  { value: null, original_name: 'relevance' },
  { value: `latest:desc`, original_name: 'latest' },
]);

const togleValue = (value) => {
  value ? navigateToView(items.value[1]) : navigateToView(items.value[0]);
  toggle.value = !toggle.value;
};

const navigateToView = (item) => {
  const hash = new URLSearchParams(route.hash.slice(1));
  hash.delete('sortBy');
  if (item.value) {
    hash.set('sortBy', item.value);
  }

  const newRoute = { ...route, ...{ hash: Array.from(hash).length ? `#${hash}` : '' } };
  emit('update:sortBy', item.value);
  return router.push(newRoute);
};

watchEffect(() => {
  toggle.value = !!props.currentSort;
});
</script>

<style scoped lang="scss">
@import '@css/vue-import';

.sortby {
  @apply ds-pb-4;
}

@include media-breakpoint-up(lg) {
  .sortby {
    @apply ds-relative ds-pb-0;
    &__content {
      @apply ds-hidden ds-absolute ds-m-5;
    }
    &:hover {
      .sortby__content {
        @apply ds-block ds-rounded-md ds-py-2 ds-m-0 ds-border ds-border-solid ds-border-neutral-300;
        &-item {
          @apply ds-m-0 ds-bg-white ds-border-none;
          border-radius: 0;
          padding: 10px 12px;
          cursor: pointer;
          &:hover {
            @apply ds-bg-neutral-300;
          }
          &--selected {
            @apply ds-bg-neutral-300 ds-text-neutral-700;
          }
        }
      }
    }
  }
}
</style>
